/* Safara Aroma: Liquid Glass lens.
   In Chromium browsers the floating glass bars bend whatever scrolls beneath
   their edges, like a real lens. Each bar gets its own displacement map sized
   to it. Other browsers keep the frosted look from liquid-glass.css. */
(function () {
  'use strict';
  var doc = document, root = doc.documentElement;
  var brands = navigator.userAgentData && navigator.userAgentData.brands;
  var chromium = !!(brands && brands.some(function (b) { return /Chromium/.test(b.brand); }));
  var mq = function (q) { return window.matchMedia && window.matchMedia(q).matches; };
  // Phones skip the lens: re-running the displacement filter on every scroll frame makes swipes stutter.
  if (!chromium || !doc.body.classList.contains('liquid-glass') || mq('(prefers-reduced-transparency: reduce)') || mq('(pointer: coarse)')) return;

  var NS = 'http://www.w3.org/2000/svg';
  var svg = doc.createElementNS(NS, 'svg');
  svg.setAttribute('aria-hidden', 'true');
  svg.setAttribute('width', '0'); svg.setAttribute('height', '0');
  svg.style.cssText = 'position:absolute;width:0;height:0;overflow:hidden';
  doc.body.appendChild(svg);
  root.classList.add('lg-lens');

  // Red = sideways shift, green = vertical shift, 128 = none. Pixels within the
  // bezel sample from further inside the shape, so edges look curved.
  function lensMap(w, h, r, bezel) {
    var c = doc.createElement('canvas'); c.width = w; c.height = h;
    var ctx = c.getContext('2d'), img = ctx.createImageData(w, h), d = img.data;
    var hx = w / 2, hy = h / 2;
    for (var y = 0; y < h; y++) {
      for (var x = 0; x < w; x++) {
        var px = x + .5 - hx, py = y + .5 - hy, ax = Math.abs(px), ay = Math.abs(py);
        var qx = ax - (hx - r), qy = ay - (hy - r), dist, nx = 0, ny = 0;
        if (qx > 0 && qy > 0) {
          var len = Math.sqrt(qx * qx + qy * qy) || 1;
          dist = r - len; nx = qx / len; ny = qy / len;
        } else if (hx - ax < hy - ay) { dist = hx - ax; nx = 1; }
        else { dist = hy - ay; ny = 1; }
        var m = dist < bezel ? Math.pow(1 - Math.max(dist, 0) / bezel, 2) : 0;
        var i = (y * w + x) * 4;
        d[i] = 128 - (px < 0 ? -nx : nx) * m * 127;
        d[i + 1] = 128 - (py < 0 ? -ny : ny) * m * 127;
        d[i + 2] = 128; d[i + 3] = 255;
      }
    }
    ctx.putImageData(img, 0, 0);
    return c.toDataURL();
  }

  var n = 0;
  function lens(el, strength) {
    var id = 'lg-lens-' + (++n);
    var filter = doc.createElementNS(NS, 'filter');
    filter.setAttribute('id', id);
    filter.setAttribute('filterUnits', 'userSpaceOnUse');
    filter.setAttribute('color-interpolation-filters', 'sRGB');
    var image = doc.createElementNS(NS, 'feImage');
    image.setAttribute('result', 'map');
    image.setAttribute('preserveAspectRatio', 'none');
    var disp = doc.createElementNS(NS, 'feDisplacementMap');
    disp.setAttribute('in', 'SourceGraphic'); disp.setAttribute('in2', 'map');
    disp.setAttribute('xChannelSelector', 'R'); disp.setAttribute('yChannelSelector', 'G');
    filter.appendChild(image); filter.appendChild(disp); svg.appendChild(filter);
    var last = '';
    function build() {
      var w = Math.round(el.offsetWidth), h = Math.round(el.offsetHeight);
      if (!w || !h || w * h > 400000) return;
      var key = w + 'x' + h;
      if (key === last) return;
      last = key;
      var r = Math.min(parseFloat(getComputedStyle(el).borderTopLeftRadius) || 0, w / 2, h / 2);
      var bezel = Math.max(8, Math.min(22, h * .34));
      ['x', 'y'].forEach(function (a) { filter.setAttribute(a, '0'); image.setAttribute(a, '0'); });
      filter.setAttribute('width', w); filter.setAttribute('height', h);
      image.setAttribute('width', w); image.setAttribute('height', h);
      image.setAttribute('href', lensMap(w, h, r, bezel));
      disp.setAttribute('scale', strength);
      el.style.setProperty('--lens', 'url(#' + id + ')');
    }
    build();
    if ('ResizeObserver' in window) {
      var t; new ResizeObserver(function () { clearTimeout(t); t = setTimeout(build, 120); }).observe(el);
    }
  }

  function init() {
    doc.querySelectorAll('.tab-bar, .sticky-atc, .collection-toolbar').forEach(function (el) { lens(el, 36); });
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init); else init();
})();
